module.exports.gisRoutes = {
  visitor: {
    dashboard: "/visitor",
    service_number_coverage_id: "/visitor/service_number_coverage/:id",
    service_number_coverage: "/visitor/service_number_coverage",
    contacts: "/visitor/contacts",
    profile: "/visitor/profile"
  },
  dashboard: {
    administrator: "/portal/dashboard/admin",
    pccwglobal_sales: "/portal/dashboard/pccwglobal_sales/",
    pccwglobal_product: "/portal/dashboard/pccwglobal_product/",
    pccwglobal_billing: "/portal/dashboard/pccwglobal_billing/",
    pccwglobal_operation: "/portal/dashboard/pccwglobal_operation/",
    master: "/portal/dashboard/master/",
    "sub-account-sales": "/portal/dashboard/sub-account-sales/",
    "sub-account-product": "/portal/dashboard/sub-account-product/",
    "sub-account-billing": "/portal/dashboard/sub-account-billing/",
    "sub-account-operation": "/portal/dashboard/sub-account-operation/",
    registered: "/visitor",
  },
  account: {
    login: "/account/login",
    register: "/account/register",
    logout: "/account/logout",
    forgot_password: "/account/forgot-password",
    reset_password: "/account/reset-password/:token",
    update_password: "/portal/update-password",
    account: {
      list: "/portal/account/accounts",
      add: "/portal/account/accounts/add",
      edit: "/portal/account/accounts/edit/:id",
      delete: "/portal/account/accounts/delete/:id"
    },
    customer: {
      list: "/portal/account/customers",
      add: "/portal/account/customers/add",
      from_master: "/portal/account/customers/master/:id",
      bulk: "/portal/account/customers/bulk",
      edit: "/portal/account/customers/edit/:id",
      delete: "/portal/account/customers/delete/:id",
      master: "/portal/account/customers/addmaster/:id",
    },
    profile: "/portal/profile",
  },
  management: {
    order: {
      list: "/portal/management/orders",
      add: "/portal/management/orders/add",
      submitOrder: "/portal/management/orders/add/submit-order",
      read: "/portal/management/orders/show/:id",
      edit: "/portal/management/orders/edit/:id",
      delete: "/portal/management/orders/delete/:id"
    },
    service_number_coverage: {
      list: "/portal/management/service_number_coverage",
      read: "/portal/management/service_number_coverage/show/:id",
    },
    service_number_type: {
      list: "/portal/management/service_number_types",
      bulk: "/portal/management/service_number_types/bulk",
      add: "/portal/management/service_number_types/add",
      edit: "/portal/management/service_number_types/edit/:id",
      delete: "/portal/management/service_number_types/delete/:id"
    },
    invnumber: {
      list: "/portal/management/invnumbers",
      add: "/portal/management/invnumbers/add",
      bulk: "/portal/management/invnumbers/bulk",
      read: "/portal/management/invnumbers/show/:id",

    },
    carrier: {
      list: "/portal/management/carriers",
      bulk: "/portal/management/carriers/bulk",
    },
    tariff: {
      list: "/portal/management/tariff",
      add: "/portal/management/tariff/add",
      edit: "/portal/management/tariff/edit/:id",
      delete: "/portal/management/tariff/delete/:id"
    },
    vendor: {
      list: "/portal/management/vendor",
      bulk: "/portal/management/vendor/bulk",
      add: "/portal/management/vendor/add",
      edit: "/portal/management/vendor/edit/:id",
      delete: "/portal/management/vendor/delete/:id"
    }
  },
  notification: {
    notification: {
      list: "/portal/notification/notifications",
      read: "/portal/notification/notifications/:id",
    }
  },
  administration: {
    configuration: {
      edit: "/portal/administration/configuration/edit"
    },
    account_type: {
      list: "/portal/administration/account_types",
      add: "/portal/administration/account_types/add",
      edit: "/portal/administration/account_types/edit/:id",
      delete: "/portal/administration/account_types/delete/:id"
    },
    permission: {
      list: "/portal/administration/permissions",
      add: "/portal/administration/permissions/add",
      edit: "/portal/administration/permissions/edit/:id",
      delete: "/portal/administration/permissions/delete/:id"
    },
    notification_type: {
      list: "/portal/administration/notification_types",
      add: "/portal/administration/notification_types/add",
      edit: "/portal/administration/notification_types/edit/:id",
      delete: "/portal/administration/notification_types/delete/:id"
    },
    functionality: {
      list: "/portal/administration/functionalities",
      add: "/portal/administration/functionalities/add",
      edit: "/portal/administration/functionalities/edit/:id",
      delete: "/portal/administration/functionalities/delete/:id"
    }
  },
  reporting: {
    list: "/portal/reporting/reports",
    add: "/portal/reporting/reports/add",
  },
  download: {
    list: "/portal/downloads",
  },
  support: {
    contacts: "/portal/support/contacts",
    tickets: {
      // list: "/portal/support/tickets",
      add: "/portal/support/tickets/add"
    },
  },
  report: {
    summary_overview: "/portal/report/summary_overview",
    call_statistics: "/portal/report/call_statistics/daily",
    call_statistics_h: "/portal/report/call_statistics/hourly",
    call_records: "/portal/report/call_records"
  }
}
